import { Column, DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { EmailInput, ImageInput, PhoneInput, TextareaInput, TextInput, MoneyInput, AsyncSelect } from "../../components/forms/Inputs"
import { postalCodeToCommune } from "../../hooks/helpers"
import { useOptions } from "../../hooks/useOptions"
import { useTranslations } from "../../layers/Localization"
import { TvaInput } from "./Clients"

function SocieteFields({ item, set, tab }) {
    const t = useTranslations()
    const personnelOptions = useOptions('personnel', ['prenom', 'nom', 'fonction'], { query: 'signataire=true', label: x => `${x.prenom || ''} ${x.nom || ''} (${x.fonction})` })

    const onCodePostalChange = value => {
        set('codePostal')(value)
        set('commune')(postalCodeToCommune(value))
    }

    return <>
        {tab === t("Général") && <>
            <Row>
                <TextInput className="grow" label={t("Nom")} value={item.nom} onChange={set('nom')} required />
                <TextInput className="grow" label={t("Raison sociale")} value={item.raisonSociale} onChange={set('raisonSociale')} required />
                <TvaInput label={t("Numéro de TVA")} value={item.numTva} onChange={set('numTva')} required />
            </Row>
            <Row>
                <TextInput className="grow" label={t("Adresse")} value={item.adresse} onChange={set('adresse')} required />
                <TextInput label={t("Code postal")} value={item.codePostal} onChange={onCodePostalChange} required />
                <TextInput label={t("Commune")} value={item.commune} onChange={set('commune')} required />
            </Row>
            <Row>
                <ImageInput label={t("Logo")} value={item.logo} onChange={set('logo')} />
                <Column>
                    <EmailInput className="grow" label={t("Email")} value={item.email} onChange={set('email')} required />
                    <Row>
                        <PhoneInput className="grow" label={t("Telephone")} value={item.telephone} onChange={set('telephone')} />
                        <PhoneInput className="grow" label={t("Mobile")} value={item.mobile} onChange={set('mobile')} />
                    </Row>
                    <TextInput label={t("Site web")} value={item.siteWeb} onChange={set('siteWeb')} />
                </Column>
            </Row>
            <Row>
                <TextInput className="grow" label={t("Dossier de programmes")} value={item.programmeFolder} onChange={set('programmeFolder')} required help={t("Vous pouvez utiliser la variables {nom} dans ce chemin d'accès")} />
                <TextInput className="grow" label={t("Dossier de check-in")} value={item.checkInFolder} onChange={set('checkInFolder')} required help={t("Vous pouvez utiliser la variables {nom} dans ce chemin d'accès")} />
                <TextInput className="grow" label={t("Dossier de contrats")} value={item.contractFolder} onChange={set('contractFolder')} required help={t("Vous pouvez utiliser les variables {nom} et {num} dans ce chemin d'accès")} />
            </Row>
            <Row>
                <TextInput className="grow" label={t("IBAN 1")} value={item.iban1} onChange={set('iban1')} required />
                <TextInput className="grow" label={t("BIC 1")} value={item.bic1} onChange={set('bic1')} required />
            </Row>
            <Row>
                <TextInput className="grow" label={t("IBAN 2")} value={item.iban2} onChange={set('iban2')} />
                <TextInput className="grow" label={t("BIC 2")} value={item.bic2} onChange={set('bic2')} />
            </Row>
            <Row>
                <MoneyInput label={t("Taux par défaut")} value={item.tauxParDefaut} onChange={set('tauxParDefaut')} />
                <AsyncSelect label={t("Signataire par défaut")} value={item.signataireParDefautId} onChange={set('signataireParDefautId')} options={personnelOptions} />
            </Row>
        </>}
        {tab === t("Configuration") && <>
            <Row>
                <TextInput className="grow" label={t("Texte indexation FR")} value={item.texteIndexationFr} onChange={set('texteIndexationFr')} />
                <TextInput className="grow" label={t("Texte indexation NL")} value={item.texteIndexationNl} onChange={set('texteIndexationNl')} />
                <TextInput className="grow" label={t("Texte indexation EN")} value={item.texteIndexationEn} onChange={set('texteIndexationEn')} />
            </Row>
            <Row>
                <TextareaInput className="grow" label={t("Offre comprend FR")} value={item.comprendBienFr} onChange={set('comprendBienFr')} />
                <TextareaInput className="grow" label={t("Offre comprend NL")} value={item.comprendBienNl} onChange={set('comprendBienNl')} />
                <TextareaInput className="grow" label={t("Offre comprend EN")} value={item.comprendBienEn} onChange={set('comprendBienEn')} />
            </Row>
            <Row>
                <TextareaInput className="grow" label={t("Mention légale autoliquidation FR")} value={item.mentionLegaleAutoliquidationFr} onChange={set('mentionLegaleAutoliquidationFr')} />
                <TextareaInput className="grow" label={t("Mention légale autoliquidation NL")} value={item.mentionLegaleAutoliquidationNl} onChange={set('mentionLegaleAutoliquidationNl')} />
                <TextareaInput className="grow" label={t("Mention légale autoliquidation EN")} value={item.mentionLegaleAutoliquidationEn} onChange={set('mentionLegaleAutoliquidationEn')} />
            </Row>
            <Row>
                <TextareaInput className="grow" label={t("Offre ne comprend pas FR")} value={item.comprendPasFr} onChange={set('comprendPasFr')} />
                <TextareaInput className="grow" label={t("Offre ne comprend pas NL")} value={item.comprendPasNl} onChange={set('comprendPasNl')} />
                <TextareaInput className="grow" label={t("Offre ne comprend pas EN")} value={item.comprendPasEn} onChange={set('comprendPasEn')} />
            </Row>
            <Row>
                <TextInput className="grow" label={t("Forfait pour FR")} value={item.forfait1PourFr} onChange={set('forfait1PourFr')} />
                <TextInput className="grow" label={t("Forfait pour NL")} value={item.forfait1PourNl} onChange={set('forfait1PourNl')} />
                <TextInput className="grow" label={t("Forfait pour EN")} value={item.forfait1PourEn} onChange={set('forfait1PourEn')} />
            </Row>
            <Row>
                <TextInput className="grow" label={t("Conditions générales de vente FR")} value={item.conditionsGeneralesDeVenteFr} onChange={set('conditionsGeneralesDeVenteFr')} />
                <TextInput className="grow" label={t("Conditions générales de vente NL")} value={item.conditionsGeneralesDeVenteNl} onChange={set('conditionsGeneralesDeVenteNl')} />
                <TextInput className="grow" label={t("Conditions générales de vente EN")} value={item.conditionsGeneralesDeVenteEn} onChange={set('conditionsGeneralesDeVenteEn')} />
            </Row>
        </>}
    </>
}

export function SocietesList(props) {
    const t = useTranslations()
    return <ListPage model="societes" title={t("Sociétés")} columns={{
        [t('Nom')]: 'nom',
        [t('Numéro de TVA')]: 'numTva',
        [t('Adresse')]: 'adresse',
        [t('Code postal')]: 'codePostal',
        [t('Commune')]: 'commune',
    }} {...props} />
}

export function SocieteDetail(props) {
    const t = useTranslations()
    return <DetailPage model="societes" title={t("Société")} Fields={SocieteFields} tabs={[t("Général"), t("Configuration")]} {...props} />
}
